import {
  createColumnVisibilityStore,
  type ColumnDefinition,
} from "./createColumnVisibilityStore";

/**
 * The resource table's columns, in render order.
 *
 * Labels match the table headers exactly — the menu is a list of what is on screen, so a different
 * wording there reads as a different column.
 *
 * Locked ones are the three a row cannot be read or acted on without: the selection checkbox that
 * bulk actions depend on, the name that says which VM this is, and the actions menu. `STT` is left
 * unlocked: it is only a row counter.
 */
export const RESOURCE_COLUMNS = [
  { id: "select", label: "Selection", locked: true },
  { id: "index", label: "STT" },
  { id: "name", label: "Resource Name", locked: true },
  { id: "status", label: "Status" },
  { id: "user", label: "User" },
  { id: "expiredAt", label: "ExpiredAt" },
  { id: "specs", label: "Specs" },
  { id: "network", label: "IP / OS / CPU" },
  { id: "type", label: "Type" },
  { id: "order", label: "Order" },
  { id: "tenant", label: "Tenant" },
  { id: "createdAt", label: "Created At" },
  { id: "actions", label: "Actions", locked: true },
] as const satisfies readonly ColumnDefinition[];

export type ResourceColumnId = (typeof RESOURCE_COLUMNS)[number]["id"];

export const useResourceColumnsStore =
  createColumnVisibilityStore<ResourceColumnId>({
    name: "admin.resources.columns",
    columns: RESOURCE_COLUMNS,
  });
